import { h, Component } from 'preact'
import PostAPI from '../api/PostAPI'
import Posts from '../components/Posts'
import LoadMorePosts from '../components/LoadMorePosts'
import CheckboxFilter from './CheckboxFilter'
import SubmitFilters from '../components/SubmitFilters'
import ClearFilters from '../components/ClearFilters'
import ToggleFilters from '../components/ToggleFilters'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      count: 6,
      offset: 0,
      currentTerms: {
        project_branch: '',
        project_solution: '',
      },
      totalAmountPosts: null,
      loadedAllPosts: false,
      isLoading: true,
      error: false,
      closed: true,
    }

    this.handleLoadMore = this.handleLoadMore.bind(this)
    this.handleTermChoice = this.handleTermChoice.bind(this)
    this.handleClear = this.handleClear.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleToggleFilters = this.handleToggleFilters.bind(this)
  }

  componentDidMount() {
    // check if href hash exists and is an integer (e.g. ?branch=17)
    if ( location.hash && Number.isInteger( parseInt(location.hash.substr(1)) ) ) {
      this.setState({
        currentTerms: {
          project_branch: location.hash.substr(1),
          project_solution: '',
        },
        closed: false
      }, this.fetchPosts )
    
    // fetch all
    } else {
      this.fetchPosts()
    }
  }

  fetchPosts() {
    this.setState({ isLoading: true })

    PostAPI.all(this.state)
    .then(response => {
      this.setState({
        totalAmountPosts: response.headers.get('x-wp-total')
      })
      return response.json()
    })
    .then(data => {
      window.setTimeout(() => {
        this.setState({
          posts: [...this.state.posts, ...data],
          loadedAllPosts: false,
          isLoading: false
        })
        this.verifyLoadedAllPosts()
      }, 500)
    }).catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  verifyLoadedAllPosts() {
    if ( this.state.totalAmountPosts == this.state.posts.length ) {
      return this.setState({
        loadedAllPosts: true
      })
    }

    return false
  }

  handleLoadMore() {
    this.setState( (prevState) => {
      return {
        offset: prevState.offset + this.state.count
      }
    }, this.fetchPosts )
  }

  handleTermChoice(currentTerm, taxonomy) {
    const currentTerms = this.state.currentTerms
    currentTerms[taxonomy] = currentTerm

    this.setState( () => {
      return {
        currentTerms: currentTerms
      }
    }) 

    /** Fetch as soon as a term in selected,
     *  instead using <SubmitFilters>: 
     * */
    // this.setState( () => {
    //   return {
    //     currentTerms: currentTerms, 
    //     posts: [],
    //     offset: 0
    //   }
    // }, this.fetchPosts ) 
  }

  handleClear() {
    this.setState({
      currentTerms: {
        project_branch: '',
        project_solution: ''
      },
      posts: [],
      offset: 0
    }, this.fetchPosts )
  }

  handleSubmit() {
    this.setState( () => {
      return { 
        posts: [],
        offset: 0,
        closed: true
      }
    }, this.fetchPosts )
  }

  handleToggleFilters() {
    this.setState({ closed: !this.state.closed })
  }

  render() {
    const appClass = `c-projects-app c-projects-app--${this.props.color}`

    return (
      <div className={appClass}>

        <ToggleFilters 
          number={this.state.totalAmountPosts} 
          onClick={this.handleToggleFilters} 
          closed={this.state.closed}
        />

        <div className="c-projects-filters" data-closed={this.state.closed}>

          {this.props.show_branch_filter === 'show' ? (
            <CheckboxFilter
              taxonomy="project_branch"
              currentTerms={this.state.currentTerms.project_branch}
              onSelectTerm={this.handleTermChoice}
              postsLoading={this.state.isLoading}
              title="Branches"
            />
          ) : null }

          <CheckboxFilter
            taxonomy="project_solution"
            currentTerms={this.state.currentTerms.project_solution}
            onSelectTerm={this.handleTermChoice}
            postsLoading={this.state.isLoading}
            title="Oplossingen"
          />

          <div class="c-projects-handler-buttons">
            <ClearFilters onClear={this.handleClear} />
            <SubmitFilters onSubmit={this.handleSubmit} />
          </div>

        </div>

        <Posts
          posts={this.state.posts}
          loading={this.state.isLoading}
          error={this.state.error}
        />

        <LoadMorePosts
          onLoadMore={this.handleLoadMore}
          nrShowing={this.state.posts.length}
          nrAll={this.state.totalAmountPosts}
          loading={this.state.isLoading}
          title="Toon meer projecten"
        />

      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/projects/containers/App.js